var map = {
	"./ring_1.svg": 36562,
	"./ring_2.svg": 25249,
	"./ring_3.svg": 13008,
	"./ring_4.svg": 78895,
	"./ring_5.svg": 16318,
	"./ring_6.svg": 70493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52099;